/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { GetQuestionFactory } from "../get-question.factory";
import { normalizeQuestions } from "./normalize-questions-helper";

/**
 * @param {FormReducerDraftState} state 
 * @param {FormReducerAction} action 
 */
export function QuestionReducerActions (state, action) {
    const { type } = action;

    const getQuestion = GetQuestionFactory(state);

    switch (type) {
        case "question/set-property": {
            const { guid, key, value } = action;

            const question = getQuestion(guid);
            question[key] = value;
            if (["step", "position"].includes(key)) {
                state.form.questions = normalizeQuestions(state.form.questions);
            }
            break;
        }

        case "question/add": {
            const { question } = action;
            state.form.questions.push(question);
            state.form.questions = normalizeQuestions(state.form.questions);
            break;
        }

        case "question/set": {
            const { questions } = action;
            state.form.questions = normalizeQuestions(questions);
            break;
        }

        default:
            return false;

    }

    return state;
}
